import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TokenService } from '../token/token.service';
import { environment as env } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class CurrencyService {
    private currencySubject = new BehaviorSubject<any>(null);
    selectedCurrency$ = this.currencySubject.asObservable();

    constructor(private token: TokenService) {
        this.initCurrencyFromStorage();
    }

    private initCurrencyFromStorage(): void {
        const stored = this.token.getLocalToken(env.TokenKeys.Currency);
        if (stored) {
            try {
                const currency = JSON.parse(stored);
                this.currencySubject.next(currency);
            } catch {
                this.currencySubject.next(env.DefaultLanguageCode);
            }
        }
    }

    getCurrencyList() {
        const stored = this.token.getLocalToken(env.TokenKeys.CurrencyList);

        if (typeof stored === 'string') {
            try {
                return JSON.parse(stored);
            } catch (error) {
                return [];
            }
        }

        return Array.isArray(stored) ? stored : [];
    }

    setCurrency(currency: any) {
        this.currencySubject.next(currency);
        this.token.setLocalToken(env.TokenKeys.Currency, JSON.stringify(currency));
    }

    getCurrency() {
        return this.currencySubject.value;
    }
}
